import React, {JSX} from "react";
import DashboardIcon from "@mui/icons-material/BarChart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useUser } from "../context/UserContext";
import GroupIcon from "@mui/icons-material/Group";
import BusinessCenter from "@mui/icons-material/Handshake";
import GroupsIcon from "@mui/icons-material/Groups";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CommonSidebar from "./commonSidebar";
import {ROLES} from "../constants/general.constant";
import BadgeIcon from "@mui/icons-material/Badge";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HistoryIcon from '@mui/icons-material/History';
import CampaignIcon from '@mui/icons-material/Campaign';
import NotificationsIcon from "@mui/icons-material/Notifications";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

interface ChildProps {
  openToggle: (open: boolean) => void;
  mobileOpen?: boolean;
  mobileToggle?: (open: boolean) => void;
}
interface MenuItem {
  label: string;
  icon: JSX.Element;
  path: string;
}

const businessMenuItems = [
  { label: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
  { label: "Leads", icon: <EditNoteIcon />, path: "/leads" },
  { label: "Deals", icon: <AttachMoneyIcon />, path: "/deals" },
  { label: "Inactive Deals", icon: <AssessmentIcon />, path: "/inactive-deals" },
  { label: "Co-owners", icon: <BusinessCenter />, path: "/business-co-owners" },
  { label: "Employees", icon: <GroupIcon />, path: "/employees" },
  { label: "Bankers", icon: <AccountBalanceIcon />, path: "/bankers" },
  { label: "Customers", icon: <GroupsIcon />, path: "/customers" },
  { label: "Notifications", icon: <NotificationsIcon />, path: "/notifications" },
  { label: "Task Manager", icon: <AssignmentTurnedInIcon />, path: "/tasks" },
  { label: "Social Posts", icon: <CampaignIcon />, path: "/social-posts" },
  { label: "My Account", icon: <AccountCircleIcon />, path: "/business-profile" },
];

const coOwnersMenuItems = [
  { label: "Leads", icon: <EditNoteIcon />, path: "/co-owner/leads" },
  { label: "Deals", icon: <AttachMoneyIcon />, path: "/co-owner/deals" },
  { label: "Inactive Deals", icon: <AssessmentIcon />, path: "/co-owner/inactive-deals" },
  { label: "Employee", icon: <GroupIcon />, path: "/co-owner/employees" },
  { label: "Bankers", icon: <AccountBalanceIcon />, path: "/co-owner/bankers" },
  { label: "Customers", icon: <GroupsIcon />, path: "/co-owner/customers" },
  { label: "Notifications", icon: <NotificationsIcon />, path: "/co-owner/notifications" },
  { label: "Task Manager", icon: <AssignmentTurnedInIcon />, path: "/co-owner/tasks" },
  { label: "My Account", icon: <AccountCircleIcon />, path: "/co-owner/your-profile" },
];

const employeeMenuItems = [
  { label: "Leads", icon: <EditNoteIcon />, path: "/employee/leads" },
  { label: "Deals", icon: <AttachMoneyIcon />, path: "/employee/deals" },
  { label: "Inactive Deals", icon: <AssessmentIcon />, path: "/employee/inactive-deals" },
  { label: "Bankers", icon: <AccountBalanceIcon />, path: "/employee/bankers" },
  { label: "Customers", icon: <GroupsIcon />, path: "/employee/customers" },
  { label: "Notifications", icon: <NotificationsIcon />, path: "/employee/notifications" },
  { label: "Task Manager", icon: <AssignmentTurnedInIcon />, path: "/employee/tasks" },
  { label: "My Account", icon: <AccountCircleIcon />, path: "/employee/profile" },
];

const customerMenuItems = [
  { label: "KYC", icon: <BadgeIcon />, path: "/customer/prospect-profile" },
  { label: "My Businesses", icon: <ApartmentIcon />, path: "/customer/my-businesses" },
  { label: "Notifications", icon: <NotificationsIcon />, path: "/customer/notifications" },
  { label: "Profile", icon: <AccountCircleIcon />, path: "/customer/profile" },
];

const bankerMenuItems = [
  { label: "Registration", path: "/banker/register",  icon: <HowToRegIcon  /> },
  { label: "Loan-status", path: "/banker/loan-status",  icon: <AssessmentIcon  /> },
  { label: "Notifications", path: "/banker/notifications",  icon: <NotificationsIcon /> },
  // { label: "Bid-details", path: "/banker/bid-details",  icon: <DescriptionIcon  /> },
  { label: "Profile", path: "/banker/profile",  icon: <AccountCircleIcon /> },
];

const adminMenuItems = [
  { label: "Business ", path: "/admin/business",  icon: <ApartmentIcon /> },
  { label: "Bankers ", path: "/admin/bankers",  icon: <AccountBalanceIcon /> },
  { label: "Notifications", path: "/admin/notifications", icon: <NotificationsIcon /> },
  { label: "Activity Logs", path: "/admin/activity-logs", icon: <HistoryIcon /> },
];

const Sidebar: React.FC<ChildProps> = ({ openToggle, mobileOpen, mobileToggle }) => {
  const { user: userData } = useUser();
  const [menuItems, setMenuItems] = React.useState<MenuItem[]>([])

  React.useEffect(() => {
    if(userData?.role === ROLES.BUSINESS){
     setMenuItems(businessMenuItems);
    }else if(userData?.role === ROLES.CO_OWNER){
     setMenuItems(coOwnersMenuItems);
    }else if(userData?.role === ROLES.EMPLOYEE){
     setMenuItems(employeeMenuItems);
    }else if(userData?.role === ROLES.CUSTOMER){
     setMenuItems(customerMenuItems);
    }else if(userData?.role === ROLES.BANKER){
     setMenuItems(bankerMenuItems)
    }else if(userData?.role === ROLES.ADMIN){
      setMenuItems(adminMenuItems)
    }
  }, [userData]);

  const handleToggle = (isOpen: boolean) => {
    openToggle(isOpen)
  }
  return (
    <CommonSidebar
      openToggle={handleToggle}
      menuItems={menuItems}
      userData={userData}
      mobileOpen={mobileOpen}
      mobileToggle={mobileToggle}
    />
  );
};

export default Sidebar;
